import { Component, OnInit } from '@angular/core';
import {Resource} from "../../entities/Resource";
import {EmployeeService} from "../../services/employee.service";
import {ResourceStatsService} from "../../services/resource-stats.service";

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.css']
})
export class ResourceComponent implements OnInit {

  resources : Resource[];

  constructor(private resourceStatsService: ResourceStatsService) { }

  ngOnInit() {
    this.resourceStatsService.getAllUserInfo().subscribe(x => {this.resources = x;});
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/resource/resource.component.ts